module.exports = __webpack_public_path__ + "img/workspace-default.13359388.png";